import config from 'const/config'

export const handleMakeAPaymentOffline = () => {
  const redirectURL = new URL(`${config.DTP_HOST_NAME}/accountlookup`).href

  window.open(redirectURL, '_blank', 'noopener,noreferrer')
}
